import React from 'react';
import constants from '../../common/constants';

const MainPageHelp: React.FC = () => {
  return (
    <div>
      <ul>
        <li>
          <a href="/guides/apg-library-faq.pdf" target="_blank">
            {constants.FAQ}
          </a>
        </li>
        <li>
          <a href="mailto:apg-crew@amazon.com" title="mailto:apg-crew@amazon.com">
            Contact us
          </a>
        </li>
      </ul>
    </div>
  );
};

export default MainPageHelp;
